<div fxLayoutAlign="start center">
    <mat-icon class="logo-icon mr-16" *ngIf="navigationItem.icon" [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }">
        {{ navigationItem.icon }}
    </mat-icon>
    <mat-icon class="logo-icon mr-16" *ngIf="navigationItem.svgIcon" [svgIcon]="navigationItem.svgIcon"></mat-icon>
</div>
